<template>
  <main class="page-about" id="main" tabindex="-1">
    <h1>About</h1>
    <WorkRecent view="cards"/>
  </main>
</template>

<script>
import WorkRecent from '@/components/WorkRecent.vue'

export default {
  name: 'about',
  components: {
    WorkRecent
  }
}
</script>

<style scoped>

</style>
